const $ = require('jquery')
const common = require('./common')

getCookie = function (name) {
  var cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = jQuery.trim(cookies[i]);
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

var currentPage = 1
var isLoading = false
$(window).scroll(function() {
	if($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
		 load_more()
	}
});

$(document).ready(function () {
	$('.js-more-archive').on('click', function (){ 
		load_more()
	})
})

var load_more = function page() { 
	if (isLoading) {
		return
	}
	isLoading = true
	$('.js-more-archive').html('<div class="equalizer"><span class="eq1"></span><span class="eq2"></span><span class="eq3"></span></div>')
	csrftoken = getCookie('csrftoken');
	$.ajax({
		type: "POST",
		url: '/ajax',
		data: {
      csrfmiddlewaretoken: csrftoken,
      page: ++currentPage,
      pathname: common.getPathname
		},
		dataType: 'JSON',
		success: function (data) {
			if (data.is_more) {
				isLoading = false
				$('.js-archive').append(data.html)
				$('.js-more-archive').text('بیشتر...')
			} else {
				$('.js-more-archive').text('پادکستی وجود ندارد...')
			}
		}
	});
}